import { z } from "zod";

export type StaffUser = z.infer<typeof StaffUserSchema>;
export const StaffUserSchema = z.object({
  id_account: z.number().nullable(),
  access_id: z.string(),
  name: z.string(),
  lang_cd: z
    .string()
    .nullable()
    .transform((value) => value ?? "ja"),
  icon: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  user_type: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  email: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  qr: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  sign_up_at: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  activation_type: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  mode: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  online_status: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  notification_email: z
    .number()
    .nullable()
    .transform((value) => value ?? ""),
  notification_push: z.number().nullable(),
  created_at: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  updated_at: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
});
